export default __webpack_public_path__ + "static/next-3c057cfcfa4a5154684c7c63831a90d1.png";